import { render, staticRenderFns } from "./ChartCarrierBillingChargeStats.vue?vue&type=template&id=00c324e7"
import script from "./ChartCarrierBillingChargeStats.vue?vue&type=script&lang=js"
export * from "./ChartCarrierBillingChargeStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports